import { render, staticRenderFns } from "./ModeloForm.vue?vue&type=template&id=0cbb4fa8"
import script from "./ModeloForm.vue?vue&type=script&lang=js"
export * from "./ModeloForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports